import { Controller } from "stimulus";
import RequestQueue from '../classes/RequestQueue';
import Utility from '../classes/Utility';
import { isNil } from 'lodash';

class ComponentRenderController extends Controller {
  static targets = ["render"];
  static values = {
    cacheResponse: Boolean
  }

  initialize() {
    if (!this.hasCacheResponseValue) {
      this.cacheResponseValue = false
    }
  }

  connect() {
    this.onlyShowForDevice = JSON.parse(this.data.get('onlyShowForDevice'));
    if (isNil(this.onlyShowForDevice)) {
      this.render();
    } else {
      this.responsiveRender();
    }
    let eventName = this.data.get('eventName');
    if(!isNil(eventName)) {
      EventManager.on(eventName, () => {
        this.render();
      });
    }
  }

  responsiveRender() {
    let deviceType = Utility.getDeviceType();
    if (this.onlyShowForDevice.includes(deviceType)) {
      this.render();
      this.data.set('type', null);
    } else {
      this.hide();
    }
  }

  render() {
    this.renderType = this.data.get('type');
    if (this.renderType === 'append') {
      this.append();
    } else if (this.renderType === 'replace') {
      this.replace();
    } else if (this.renderType === 'show') {
      this.show();
    }
  }

  // Retrieve render target and add as child
  async append(e) {
    if (e) {
      e.preventDefault();
    }
    const { data } = await this.__fetchRenderTarget();
    const parser = new DOMParser();
    const fragment = parser.parseFromString(data, 'text/html').body;
    const firstChild = fragment.firstElementChild || document.createElement('div');
    firstChild.setAttribute('data-component-render-target', 'render');
    this.element.appendChild(firstChild);

    const eventName = this.element.dataset.eventName;
    if (eventName) {
      EventManager.emit(`${eventName}-appended`);
    }
  }

  // Replace children with render target
  async replace(e) {
    if (e) {
      e.preventDefault();
    }
    const { data } = await this.__fetchRenderTarget();
    const parser = new DOMParser();
    const fragment = parser.parseFromString(data, 'text/html').body;
    const firstChild = fragment.firstElementChild || document.createElement('div');
    firstChild.setAttribute('data-component-render-target', 'render');

    this.element.innerHTML = '';
    this.element.appendChild(firstChild);
  }

  // Show the component
  async show() {
    if (this.hasRenderTarget) {
      this.renderTarget.classList.add("active");
    } else {
      await this.append();
      this.renderTarget.classList.add("active");
    }
  }

  // Hide the component
  hide(e) {
    if (e) {
      e.preventDefault();
    }
    if (this.hasRenderTarget) {
      this.renderTarget.classList.remove("active");
    }
  }

  disconnect() {
    if (this.hasRenderTarget) {
      this.renderTarget.remove();
    }
  }

  async __fetchRenderTarget() {
    // data-component-render-url
    const url = this.data.get('url');
    const method = this.data.get('urlMethod');
    let data = this.data.get('urlData') ? JSON.parse(this.data.get('urlData')) : null;
    let params = this.data.get('urlParams') ? JSON.parse(this.data.get('urlParams')) : null;
    if (url && this.hasRenderTarget) {
      this.renderTarget.classList.remove("active");
      try {
        return await RequestQueue.addToQueue({
          method: method || 'get',
          url,
          data,
          cached: this.cacheResponseValue
        });
      } catch (e) {
        console.log(e);
        return {};
      }
    } else {
      try {
        return await RequestQueue.addToQueue({
          method: method || 'get',
          url,
          data,
          params,
          cached: this.cacheResponseValue
        });
      } catch(e) {
        console.log(e);
        return {};
      }
    }
  }
}

export default ComponentRenderController;
